/**
 * Indicates how control of trading session and subsession transitions are performed.
 * tag: 1785
 * @readonly
 * @enum {number} (int)
 */
export enum TradSesControl {
  /** Automatic (Default) */
  Automatic = 0,
  /** Manual */
  Manual = 1,
}
